import { createContext } from "react";

type ClientExercisesContextType = {
    hasExercises: boolean;
    incompleteExercisesCount: number;
    loadClientExercises: () => void;
};

export const initialClientExercisesContext: ClientExercisesContextType = {
    hasExercises: false,
    incompleteExercisesCount: 0,
    loadClientExercises: () => {},
};

export const ClientExercisesContext = createContext(
    initialClientExercisesContext,
);
